import { AxiosApi, ApiResult } from './axiosApi';
import { SitePhotoDto, UpdateSitePhotoRequest, SitePhotoCategoryCounts, PhotoUploadRequest } from '../dtos/sitePhoto';

export class SitePhotoApi extends AxiosApi<SitePhotoDto> {
    constructor(baseUri: string, logout?: () => void, enqueueSnackbar?: any) {
        super(baseUri, 'sites', logout, enqueueSnackbar);
    }

    public uploadPhoto = (siteId: number, photoData: PhotoUploadRequest): Promise<ApiResult<SitePhotoDto>> => {
        const formData = new FormData();
        formData.append('file', photoData.file);
        
        if (photoData.category) {
            formData.append('category', photoData.category);
        }
        
        if (photoData.description) {
            formData.append('description', photoData.description);
        }

        return this.genericRequest({
            method: 'POST',
            extraPath: `${siteId}/photos`,
            data: formData,
            sendDataRaw: true,
        });
    };

    public listSitePhotos = (siteId: number, category?: string): Promise<ApiResult<SitePhotoDto[]>> => {
        const queryParams = category ? `?category=${encodeURIComponent(category)}` : '';
        return this.genericRequest({
            method: 'GET',
            extraPath: `${siteId}/photos${queryParams}`,
        });
    };

    public getPhotoDetails = (siteId: number, photoId: number): Promise<ApiResult<SitePhotoDto>> => {
        return this.genericRequest({
            method: 'GET',
            extraPath: `${siteId}/photos/${photoId}`,
        });
    };

    public updatePhotoMetadata = (siteId: number, photoId: number, updateData: UpdateSitePhotoRequest): Promise<ApiResult<void>> => {
        return this.genericRequest({
            method: 'PUT',
            extraPath: `${siteId}/photos/${photoId}`,
            data: updateData,
        });
    };

    public deletePhoto = (siteId: number, photoId: number): Promise<ApiResult<void>> => {
        return this.genericRequest({
            method: 'DELETE',
            extraPath: `${siteId}/photos/${photoId}`,
        });
    };

    public getPhotoCategoryCounts = (siteId: number): Promise<ApiResult<SitePhotoCategoryCounts>> => {
        return this.genericRequest({
            method: 'GET',
            extraPath: `${siteId}/photos/categories`,
        });
    };

    public getPhotoDownloadUrl = (siteId: number, photoId: number): string => {
        return `${this._fullBaseUri}/${this._resourceName}/${siteId}/photos/${photoId}/download`;
    };

    public downloadPhoto = (siteId: number, photoId: number): Promise<Blob> => {
        const url = this.getPhotoDownloadUrl(siteId, photoId);
        
        return fetch(url, {
            method: 'GET',
            headers: this._basicHeaders,
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Failed to download photo: ${response.statusText}`);
            }
            return response.blob();
        });
    };
} 